import { useContext } from 'react';
import { Badge, Box, DropDown, FormContext } from 'dash-ui';
import { InventoryTypeEnum, mapInventoryTypeToLabel } from 'dash-common';

import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import { BADGE_TO_INVENTORY_TYPE_COLOR_MAP } from 'containers/properties/PropertyInventory/PropetyInventory.constants';

const TypeRow = () => {
  const { formState, stateHandlers } = useContext(FormContext);

  const onChange =
    (fieldName: FormFields) => (value: string) => {
      stateHandlers[fieldName](value);
    };

  return (
    <Box mt={3} w={100}>
      <DropDown
        w={100}
        Anchor={({ isOpen }) => (
          <Badge
            h={32}
            square
            loading={false}
            type={BADGE_TO_INVENTORY_TYPE_COLOR_MAP[formState.inventoryType as InventoryTypeEnum]}
            iconRight={isOpen ? 'arrowUp' : 'arrowDown'}
            title={mapInventoryTypeToLabel[formState.inventoryType as InventoryTypeEnum]}
          />
        )}
        items={[
          {
            key: InventoryTypeEnum.MODEL,
            children: mapInventoryTypeToLabel[InventoryTypeEnum.MODEL],
            onClick: () => onChange(FormFields.InventoryType)(InventoryTypeEnum.MODEL),
          },
          {
            key: InventoryTypeEnum.FOR_SALE,
            children: mapInventoryTypeToLabel[InventoryTypeEnum.FOR_SALE],
            onClick: () => onChange(FormFields.InventoryType)(InventoryTypeEnum.FOR_SALE),
          },
        ]}
      />
    </Box>
  );
};

export default TypeRow;
